import './App.css';
import {createBrowserRouter,RouterProvider} from 'react-router-dom';
import {createContext,useState} from "react"
import Header from './components/baseComponenrs/base1.jsx'
import Men from './components/menComponents/men'
import Women from './components/womenComponents/women';
import Home from './components/homeComponents/home';
import Kids from './components/KidsComponent/kids';
import Cart from './components/cartComponent/cart';
import Wishlist from './components/wishlistComponent/wishlist';
import Payment from './components/paymentComponent/payment';
import Login from './components/loginComponent/login.jsx';

const router = createBrowserRouter([{
  path: '/',
  element : <Header />,
  children : [
    {
      path : '/',
      element : <Home />
    },
    {
      path : '/men',
      element : <Men />
    },{
      path : '/women',
      element : <Women />
    },{
      path : '/kids',
      element : <Kids />
    },{
      path : '/cart',
      element : <Cart />
    },{
      path : '/wishlist',
      element : <Wishlist />
    },{
      path : '/cart/payment',
      element: <Payment />
    },{
      path : '/login',
      element : <Login/>
    }
  ]
}])

export const userContex = createContext();
function App() {
  let [isLogin,setIsLogin] = useState(localStorage.getItem("islogin"))
  return (
    <userContex.Provider value={{isLogin,setIsLogin}}>
    <RouterProvider router={router}></RouterProvider>
    </userContex.Provider>
  )
}

export default App;
